/**
 * Make the specified organization name to be in all uppercase.
 */
export const prettifyOrganizationName = (name: string): string =>
  name.toLocaleUpperCase();
